<script setup>
import {useLanguageStore} from "@/pinia";

const languageStore = useLanguageStore();
const props = defineProps(['modalX', 'modalY','subModalValue', 'subModalType'])
const emits = defineEmits([
    'deleteItems',
    'closeModal',
    'openModal',
    'videoDownload',
    'set_isFolderModal',
    'set_isNameChangeModal',
    'set_isMoveModal',
    'set_isTransferModal',
])

const fileDelete = ()=>{
  if(Array.isArray(props.subModalValue)){
    emits("deleteItems",props.subModalValue)
  }else{
    let data = [props.subModalValue];
    emits("deleteItems",data)
  }

  emits("closeModal");
}
const openInsertModal = ()=>{
  emits("openModal", 'insert')
  emits("closeModal");
}
const videoDownload = ()=>{
  emits('videoDownload', props.subModalValue)
  emits("closeModal");
}
const openFolderModal = ()=>{
  emits('set_isFolderModal', true)
  emits("closeModal");
}
const nameChange = ()=>{
  emits('set_isNameChangeModal', true)
  emits("closeModal");
}
const deleteItems = ()=>{
  emits('deleteItems')
  emits("closeModal");
}
const videoUpdate = ()=>{
  emits('openModal', 'update', props.subModalValue)
  emits("closeModal");
}
const moveItems = ()=>{
  emits('set_isMoveModal', true);
  emits("closeModal");
}
const transferItems = ()=>{
  emits("set_isTransferModal", true);
  emits("closeModal");
}
</script>

<template>
  <div :style="{position : 'absolute', top: `${modalY-0}px`, left: `${modalX+10}px`}" @contextmenu.prevent>
    <div class="modalArea" v-if="subModalType === 'folder'">
      <div class="contents" @click="nameChange">
        <v-icon>mdi-rename-outline</v-icon>
        <div>{{languageStore.get("rename")}}</div>
      </div>
      <div class="contents" @click="moveItems">
        <v-icon>mdi-folder-move-outline</v-icon>
        <div>{{languageStore.get("move")}}</div>
      </div>
      <div class="contents" @click="deleteItems">
        <v-icon>mdi-delete-outline</v-icon>
        <div>{{languageStore.get("delete")}}</div>
      </div>
    </div>
    <div class="modalArea" v-else-if="subModalType === 'file'">
      <div class="contents" @click="videoDownload">
        <v-icon>mdi-download-outline</v-icon>
        <div>{{languageStore.get("download")}}</div>
      </div>
      <div class="contents" @click="videoUpdate">
        <v-icon>mdi-rename-outline</v-icon>
        <div>{{ languageStore.get("edit") }}</div>
      </div>
      <div class="contents" @click="moveItems">
        <v-icon>mdi-folder-move-outline</v-icon>
        <div>{{languageStore.get("move")}}</div>
      </div>
      <div class="contents" @click="transferItems">
        <v-icon>mdi-transfer</v-icon>
        <div>{{languageStore.get("transmission")}}</div>
      </div>
      <div class="contents" @click="fileDelete">
        <v-icon>mdi-delete-outline</v-icon>
        <div>{{languageStore.get("delete")}}</div>
      </div>
    </div>
    <div class="modalArea" v-else-if="subModalType === 'files'">
      <div class="contents" @click="moveItems">
        <v-icon>mdi-folder-move-outline</v-icon>
        <div>{{languageStore.get("move")}}</div>
      </div>
      <div class="contents" @click="transferItems">
        <v-icon>mdi-transfer</v-icon>
        <div>{{languageStore.get("transmission")}}</div>
      </div>
      <div class="contents" @click="fileDelete">
        <v-icon>mdi-delete-outline</v-icon>
        <div>{{languageStore.get("delete")}}</div>
      </div>
    </div>
    <div class="modalArea" v-else>
      <div class="contents" @click="openFolderModal">
        <v-icon >mdi-folder-plus-outline</v-icon>
        <div>{{languageStore.get("newFolder")}}</div>
      </div>
      <div class="contents" @click="openInsertModal">
        <v-icon>mdi-file-plus-outline</v-icon>
        <div>{{ languageStore.get("videoRegister") }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modalArea{
  border: 1px solid #C7C7C7;
  background-color: white;
  min-width: 150px;
  border-radius: 1px;
}
.contents{
  height: 4.5vh;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #C7C7C7;
  padding : 0 45px 0 10px
}
.contents div{
  margin-left: 10px;
  font-weight: bold;
  font-size: 0.9rem;
}
.contents:hover {
  background-color: #052C65;
  color: white;
  border-radius: 20px;
  cursor:pointer;
}
</style>